import type { CreateUIAnalyticsEvent } from '@atlaskit/analytics-next/types';

export const fireSpacesMenuItemClickedAnalytics =
	(
		createAnalyticsEvent: CreateUIAnalyticsEvent,
		navVersion: string,
		options: {
			componentType?: string;
			itemId?: string | null;
			itemType?: string;
			section?: string;
			parentItemType?: string | null;
			parentItemId?: string | null;
			isGuest?: boolean;
		} = {},
	) =>
	(): void => {
		const { componentType, itemId, itemType, section, parentItemType, parentItemId, isGuest } =
			options;

		createAnalyticsEvent({
			type: 'sendUIEvent',
			data: {
				source: 'globalNavigation',
				action: 'clicked',
				actionSubject: 'navigationItem',
				actionSubjectId: 'spacesNavigationMenuItem',
				attributes: {
					navigationLayer: 'global',
					navigationContainer: 'sidebar',
					navVersion,
					componentType,
					itemId,
					itemType,
					section,
					parentItemType,
					parentItemId,
					isGuest,
				},
			},
		}).fire();
	};
